<template>
    <apexcharts
        type="bar"
        :options="options"
        :series="series"
        :height="height"></apexcharts>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        name: 'design-2021-apprentice-basic-bar-chart-component',
        components: {
            apexcharts: VueApexCharts,
        },
        props: {
            series: {
                type: Array,
                default: null,
            },
            options: {
                type: Object,
                default: null,
            },
            height: {
                type: [Number, String],
                default: '100%',
            },
        },
    };
</script>

<style scoped lang="scss"></style>
